
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Inline form error / alert on the soft-destructive tint, announced via
 *  role="alert". Replaces the copy-pasted bg-[#fdecec]/text-[#c10007] banners. */
export function FormError({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  if (!children) return null;
  return (
    <p
      role="alert"
      className={cn(
        'rounded-md bg-destructive-soft px-3 py-2 text-[0.8125rem] font-medium text-destructive-soft-foreground',
        className,
      )}
    >
      {children}
    </p>
  );
}
